import type { IconName } from '../models/types';
import { renderIcon } from './icons';

/**
 * "Çok Yakında" yer tutucusu.
 *
 * Spor ve Yapılacaklar ekranları henüz planlanmadı; ama alt menüde
 * yerlerini şimdiden alıyorlar. Boş bir sayfa göstermek yerine ne
 * olduklarını söyleyen ortak bir ekran veriyoruz — kullanıcı sekmeye
 * dokununca "bozuk mu?" diye düşünmesin.
 *
 * İki ekran da aynı bileşeni kullanır; ileride biri gerçek içerikle
 * doldurulunca yalnızca `app.ts`'teki yönlendirmesi değişir.
 */

export interface ComingSoonOptions {
  /** Sayfa başlığı — alt menüdeki sekme adıyla aynı olmalı. */
  title: string;
  /** Ortada gösterilecek büyük ikon. */
  icon: IconName;
}

export function renderComingSoon(
  container: HTMLElement,
  options: ComingSoonOptions,
): void {
  container.innerHTML = `
    <h1 class="page-title">${options.title}</h1>
    <div class="coming-soon">
      <span class="coming-soon__icon">
        ${renderIcon(options.icon, { size: 40, strokeWidth: 1.6 })}
      </span>
      <p class="coming-soon__title">Çok Yakında</p>
      <p class="coming-soon__text">Bu alan ileride ayrıca planlanacak.</p>
    </div>
  `;
}
